/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	requiredValidator
} from '@entity/entity-formly-definitions';
import {
	IValidator
} from '@shared/interfaces/application-objects/validator.interface';
import {
	BaseRuleValidator
} from '@shared/validators/base-rule-validator.validator';

/**
 * A class representing a required validator.
 *
 * @export
 * @class RequiredValidator
 * @extends {BaseRuleValidator}
 */
export class RequiredValidator
	extends BaseRuleValidator
{
	/**
	 * Creates and returns a unique instance of a required validator.
	 *
	 * @returns {IValidator}
	 * A validator ready for use in a Formly layout.
	 * @memberof RequiredValidator
	 */
	public create(): IValidator
	{
		return <IValidator>
			{
				expression: requiredValidator,
				message: 'This value is required.'
			};
	}
}